import type { ApiGetWorkflowResponseWithUsages } from '@jira/project-settings__workflow-types/src/workflowTypes.types.tsx';
import {
	type ResourceStoreContext,
	type RouteResource,
	type RouterDataContext,
	type UseResourceHookResponse,
	createResource,
	useResource,
} from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { fetchWorkflowDocument, fetchWorkflowDocumentOld } from './services/index.tsx';

export const RESOURCE_TYPE_KEY = 'ADMIN_WORKFLOW_DOCUMENT';

export const workflowDocumentResource: RouteResource<ApiGetWorkflowResponseWithUsages> =
	createResource<ApiGetWorkflowResponseWithUsages>({
		type: RESOURCE_TYPE_KEY,
		getKey: (matchedRoute) => {
			const { workflowId } = matchedRoute.match.params;
			return `${RESOURCE_TYPE_KEY}_${workflowId}`;
		},
		getData: async (routerContext: RouterDataContext, customContext: ResourceStoreContext) =>
			fg('hix-7599_support_projectdetails_resource_in_tmp')
				? fetchWorkflowDocument(routerContext, customContext, false)
				: fetchWorkflowDocumentOld(routerContext, customContext, false),
		maxAge: 0,
		isBrowserOnly: true,
	});

export const useWorkflowDocument = (): UseResourceHookResponse<ApiGetWorkflowResponseWithUsages> =>
	useResource<ApiGetWorkflowResponseWithUsages>(workflowDocumentResource);
